import Pusher from 'pusher-js'

export default new Pusher(process.env.PUSHER_KEY, {
  cluster: process.env.PUSHER_CLUSTER,
})
